import React from "react";

function EyeCloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="33"
      viewBox="0 0 35 33"
    >
      <g
        id="Group_27869"
        data-name="Group 27869"
        transform="translate(6886 24407)"
      >
        <rect
          id="Rectangle_11971"
          data-name="Rectangle 11971"
          width="35"
          height="33"
          transform="translate(-6886 -24407)"
          fill="#596970"
          opacity="0"
        />
        <path
          id="Path_18886"
          data-name="Path 18886"
          d="M4.833,6.359,1.413,2.94,2.96,1.394,24.61,23.044l-1.546,1.547-3.62-3.62A12.033,12.033,0,0,1,1.182,12.992,12.009,12.009,0,0,1,4.833,6.359ZM16.027,17.554l-1.6-1.6a3.282,3.282,0,0,1-4.375-4.375l-1.6-1.6a5.468,5.468,0,0,0,7.577,7.577ZM8.61,3.981a12.039,12.039,0,0,1,16.233,9.011,11.971,11.971,0,0,1-2.2,5.022l-4.221-4.221a5.472,5.472,0,0,0-6.21-6.21Z"
          transform="translate(-6882.182 -24403.393)"
          fill="#596970"
        />
      </g>
    </svg>
  );
}

export default EyeCloseIcon;
